import React from 'react';
import ArrowButton from '../../Buttons/ArrowButton/ArrowButton';

import classes from './CardArrow.module.scss';

const CardArrow = ({ Icon, title, name, description, open, children, onClick }) => {
  return (
    <div className={classes.card}>
      <div className={classes.type}>
        <div>
          <Icon className={classes.icon} />
        </div>
        <div className={classes.text}>
          <span className='medium-16'>{title}</span>
          <span className={`${classes.color} medium-14`}>{description}</span>
        </div>
        <ArrowButton name={name} onClick={onClick} open={open} />
      </div>
      {open && children}
    </div>
  );
};

export default CardArrow;
